import {Alert, Col, Collapse, Row, Spin} from 'antd'
import TemperatureChart from './target-dashboard/temperature-chart'
import {useEffect, useMemo, useState} from 'react'
import {CARDS_GUTTER} from 'helpers/dashboards'
import {GET} from 'helpers/api'
import {useSelector} from 'react-redux'
import moment from 'moment'
import TemperatureDetails from './target-dashboard/temperature-details'
import {calcInterval} from 'helpers/chart'
import ThermalRow from './gateway-dashboard/thermal-row'
import React from 'react'

export const TemperatureEventAnalysis = ({targetsview, period}) => {
  const [temperatures, setTemperatures] = useState(null)
  const [temperature, setTemperature] = useState(null)
  const [interval, setInterval] = useState(null)
  const token = useSelector(state => state.auth.token)

  useEffect(() => {
    const loadData = async interval => {
      let data = []
      let response = {meta: {page: 0}}
      do {
        response = await getTemperaturesview(interval.name, +response.meta.page + 1)
        data = data.concat(response.temperaturesview)
      } while (moreData(response.meta))
      // Add timestamp field to each object
      data = data.map(obj => {
        return {timestamp: obj.interval, max: obj.max_max, min: obj.min_min, ...obj}
      })
      setTemperatures(data)
      setTemperature(data[data.length - 1])
      setInterval(interval)
    }

    if (period) {
      loadData(calcInterval(period))
    } else {
      setTemperatures(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [targetsview, period])

  const periodDisplayRange = useMemo(() => {
    console.log('period', period)
    if (period?.start && period?.end) {
      const rangeStart = period?.start.split('T')[0]
      const rangeEnd = new moment(period.end).add(-1, 'days').toISOString().split('T')[0]
      return rangeStart === rangeEnd ? rangeStart : rangeStart + ' - ' + rangeEnd
    } else {
      return ''
    }
  }, [period])

  const moreData = meta => {
    return meta.page * meta.pageSize < meta.total
  }

  const getTemperaturesview = (interval, page) => {
    const groupBy = `tg_id,${interval}`
    const request = GET(token)
    return fetch(
      process.env.REACT_APP_BACKEND_URL +
        `/temperaturesview?tg_id=${targetsview.tg_id}&start=${period.start}&end=${period.end}&count=${groupBy}&page=${page}&limit=1000`,
      request
    )
      .then(async res => {
        return res.json()
      })
      .then(response => {
        return response
      })
  }

  if (targetsview && temperatures && temperatures.length > 0) {
    return (
      <>
        <Row gutter={CARDS_GUTTER} style={{margin: '0em'}} align="middle">
          <Col xs={24} md={5}>
            <TemperatureDetails temperature={temperature} interval={interval} />
          </Col>
          <Col xs={24} md={19}>
            <TemperatureChart
              targetsview={targetsview}
              temperatures={temperatures}
              setTemperature={setTemperature}
              height={300}
            />
          </Col>
        </Row>
        <Collapse defaultActiveKey={['2']}>
          <Collapse.Panel header="Thermal Images for Selected Range" key="1">
            <ThermalRow targetsview={targetsview} temperature={temperature} interval={interval} />
          </Collapse.Panel>
          <Collapse.Panel header="Temperature Image Gallery (First 3 After Start)" key="2">
            <TemperatureImageGallery temperatures={temperatures} datetime={period?.start} />
          </Collapse.Panel>
        </Collapse>
      </>
    )
  } else if (!temperatures) {
    return (
      <div style={{minHeight: '500px'}}>
        <Spin />
      </div>
    )
  } else if (temperatures?.length === 0) {
    return (
      <Alert
        message={`There are no target temperatures for this date range [${periodDisplayRange}]`}
        type="info"
        style={{margin: '20px auto', textAlign: 'center', backgroundColor: 'var(--blue-20'}}
      />
    )
  }
}

export default TemperatureEventAnalysis

/**
 * Displays up to 3 temperature records (>= datetime) with color and thermal images.
 * @param {Object[]} temperatures - Array of temperature objects (must have timestamp, colorImageUrl, thermalImageUrl)
 * @param {string|Date} datetime - ISO string or Date to filter from
 */
export const TemperatureImageGallery = ({temperatures, datetime}) => {
  if (!temperatures || !datetime) return null
  // Parse datetime to moment for comparison
  const momentDatetime = moment(datetime)
  // Filter and take first 3
  const selectedTemps = temperatures.filter(t => moment(t.timestamp).isSameOrAfter(momentDatetime)).slice(0, 3)

  if (selectedTemps.length === 0) {
    return <Alert message="No images found for the selected datetime or after." type="info" />
  }

  return (
    <Row gutter={16} style={{marginTop: 24}}>
      {selectedTemps.map((temp, idx) => (
        <Col xs={24} md={8} key={temp.timestamp || idx}>
          <div style={{textAlign: 'center', marginBottom: 16}}>
            <div>
              <b>{moment(temp.timestamp).format('YYYY-MM-DD HH:mm')}</b>
            </div>
            <div style={{display: 'flex', justifyContent: 'center', gap: 8, marginTop: 8}}>
              {temp.colorImageUrl && (
                <img
                  src={temp.colorImageUrl}
                  alt="Color"
                  style={{maxWidth: 120, maxHeight: 120, border: '1px solid #ccc', marginRight: 4}}
                />
              )}
              {temp.thermalImageUrl && (
                <img
                  src={temp.thermalImageUrl}
                  alt="Thermal"
                  style={{maxWidth: 120, maxHeight: 120, border: '1px solid #ccc', marginLeft: 4}}
                />
              )}
            </div>
          </div>
        </Col>
      ))}
    </Row>
  )
}
